import { InputAdornment, TextField as TextFieldInput } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';
import React, { useCallback, useContext } from 'react';
import { OrderReviewContext } from '../../../OrderReviewContext';
import { getAnswerImages, getInitialTextValue } from '../../FormDefinitionInput.utils';
import styles from './TextField.styles';

const propTypes = {
  classes: PropTypes.object.isRequired,
  formDefinition: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  imageToEdit: PropTypes.object,
  saveAnswers: PropTypes.func.isRequired,
  updateFormHeaders: PropTypes.func.isRequired,
};

const TextField = ({
  classes,
  formDefinition,
  isReadOnly,
  imageToEdit,
  saveAnswers,
  updateFormHeaders,
  inputStyle,
}) => {
  const { dispatch: orderReviewDispatch, state } = useContext(OrderReviewContext);

  const updateAnswers = async value => {
    const answerImages = getAnswerImages(formDefinition, imageToEdit, value);
    const newAnswers = [
      {
        orderFormHeaderId: formDefinition.orderFormHeaderId,
        formDefinitionId: formDefinition.formDefinitionId,
        questionId: formDefinition.questionId,
        formQaAnswerId: formDefinition.answers.length !== 0 ? formDefinition.answers[0].formQaAnswerId : null,
        type: formDefinition.answerType,
        valueId: null,
        value: null,
        text: value.trim(),
        modifiedOn: new Date(),
        images: answerImages,
        default: false,
      },
    ];

    updateFormHeaders(newAnswers);
    orderReviewDispatch({
      type: 'IS_EDITING',
      value: true,
    });
    saveAnswers(newAnswers);

    if ((value === '' || value === null) && imageToEdit) {
      removeAnswerFromPhoto(value);
    }
  };

  const debounceHandler = useCallback(
    debounce(value => {
      updateAnswers(value);
    }, 500),
    [formDefinition.orderFormHeaderId],
  );

  const removeAnswerFromPhoto = textValue => {
    if (formDefinition.answers.length > 0) {
      let answer = formDefinition.answers[0];

      if (answer.text) {
        answer.text = textValue;
      }

      if (answer.images?.length) {
        let photoExists = answer.images.some(i => i.formQaImageId === imageToEdit.formQaImageId);
        if (photoExists) {
          answer.images = answer.images.filter(i => i.formQaImageId !== imageToEdit.formQaImageId);
        } else {
          answer.images = answer.images.concat(imageToEdit);
        }
      }

      updateFormHeaders([answer]);
      orderReviewDispatch({
        type: 'IS_EDITING',
        value: true,
      });
      saveAnswers([answer]);
    }
  };

  // this is not smart, we are debouncing every time a character is added
  // instead we should let everything flow as normal, and only try and save when tect isn't being inputted
  const handleOnChange = value => {
    orderReviewDispatch({
      type: 'IS_EDITING',
      value: true,
    });

    debounceHandler(value);
  };

  switch (formDefinition.answerType) {
    case 'TextBox':
    case 'TextArea':
    case 'Address':
      return (
        <TextFieldInput
          key={`${formDefinition.orderFormHeaderId}-${formDefinition.formDefinitionId}-${state.valuationHistory?.length}`}
          id={`fd-${formDefinition.orderFormHeaderId}-${formDefinition.formDefinitionId}`}
          className={classes.textField}
          defaultValue={getInitialTextValue(formDefinition)}
          onChange={event => handleOnChange(event.target.value)}
          margin="none"
          value={state.text}
          disabled={isReadOnly}
          multiline
          style={inputStyle}
        />
      );
    case 'Float':
    case 'Percentage':
    case 'Currency':
    case 'Number of items':
      const answerTypeAdornments = {
        Currency: {
          startAdornment: <InputAdornment position="start">$</InputAdornment>,
        },
        Percentage: {
          endAdornment: <InputAdornment position="end">%</InputAdornment>,
        },
      };
      const inputPropAdornments = answerTypeAdornments[formDefinition.answerType];
      return (
        <TextFieldInput
          key={`${formDefinition.orderFormHeaderId}-${formDefinition.formDefinitionId}-${state.valuationHistory?.length}`}
          id={`fd-${formDefinition.orderFormHeaderId}-${formDefinition.formDefinitionId}`}
          className={classes.textField}
          defaultValue={getInitialTextValue(formDefinition)}
          onChange={event => handleOnChange(event.target.value)}
          margin="none"
          type="number"
          disabled={isReadOnly}
          multiline
          InputProps={inputPropAdornments}
          style={inputStyle}
        />
      );
    default:
      console.log('This answer type is not recogized.');
      return null;
  }
};

TextField.propTypes = propTypes;
export default withStyles(styles)(TextField);
